import React, { useEffect } from "react";

const Resume = () => {
  useEffect(() => {
    window.location.replace("/files/Samuel_Park_Resume_2025.pdf");
  }, []);
  return null;
};

export default Resume;
